module.exports = __webpack_public_path__ + "img/c2.58fc2776.png";